import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/arrow-icon.png';

const _withScopeId = n => (_pushScopeId("data-v-7bd69d48"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "resource-base-card"
};
const _hoisted_2 = {
  class: "info"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = {
  class: "description"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_0,
  alt: ""
}, null, -1));

export default /*#__PURE__*/_defineComponent({
  props: {
    title: String,
    description: String
  },

  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(__props.title), 1), _createElementVNode("div", _hoisted_4, _toDisplayString(__props.description), 1)]), _hoisted_5]);
    };
  }

});